module.exports = window.__ENV__;
